import {useState} from 'react';
import {SUBTITLE2} from '@/utils/constants';
import {Box, Typography} from '@mui/material';
import {ReactComponent as EllipseIcon} from '@icons/ellipse-blue.svg';
import {ReactComponent as WarningIcon} from '@icons/warning.svg';
import {AttentionItemStyle} from './AttentionItemStyle.styles';
import Modal from '@/shared/components/Modal';
import {AttentionType} from '@/utils/enums';
import {OrganizationDashboardService} from '@/utils/services';
import {useGetOrganizationId} from '@/utils/hooks';
import {toast} from 'react-toastify';
import {calculateNotificationTime, getErrorMessage} from '@/utils/helpers';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector} from '@/store/organization-event';
import {getDashboardAttentionList} from '@/store/organization-dashboard';

interface IAttentionItem {
	id: number;
	type: AttentionType;
	title: string;
	description: string;
	createdAt: string;
	count: number;
}

const AttentionItem = ({item}: {item: IAttentionItem}) => {
	const dispatch = useAppDispatch();

	const organizationId = useGetOrganizationId();
	const currentEvent = useAppSelector(getCurrentEventSelector);

	const [open, setOpen] = useState(false);

	const handleModal = () => setOpen(!open);

	const handleIgnoreMessage = async (id: number) => {
		if (!organizationId || !currentEvent) return;

		try {
			await OrganizationDashboardService.ignoreDashboardAttentionItem({organizationId, attentionId: id});
			dispatch(getDashboardAttentionList({organizationId, eventId: currentEvent.id})).unwrap();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	return (
		<Box sx={AttentionItemStyle.wrapper} onClick={handleModal}>
			<Box sx={AttentionItemStyle.icon}>
				<EllipseIcon />
			</Box>

			<Box sx={AttentionItemStyle.content}>
				<Typography sx={AttentionItemStyle.title} variant={SUBTITLE2}>
					{item.title}
				</Typography>

				<Typography sx={AttentionItemStyle.description} variant={SUBTITLE2}>
					{item.description}
				</Typography>
			</Box>
			<Box>
				<Typography sx={AttentionItemStyle.date}>{calculateNotificationTime(item.createdAt)}</Typography>
			</Box>
			<Modal
				onClose={handleModal}
				open={open}
				isShowCloseButton
				isShowSaveButton
				title={item.title}
				description={item.description}
				mainButtonTitle="Ignore"
				onSave={() => handleIgnoreMessage(item.id)}
				closeButtonTitle="Remind Later"
				mainIcon={<WarningIcon />}
				sx={AttentionItemStyle.modal}
			/>
		</Box>
	);
};

export default AttentionItem;
